import {
	consumePendingClientLocale,
	createI18nInstance,
	initLocaleCookie,
	readStoredLanguagePreference,
	resolveAppLocale,
	resolveHydrationLocale,
	resolveSsrLocale,
	setLanguage,
} from "~/i18n/index";
import { parseLocaleFromPath } from "~/utils/i18n-locale-routes";

/** 全端掛載 vue-i18n，支援 SSR 與 $t / useI18n */
export default defineNuxtPlugin(nuxtApp => {
	const localeCookie = useCookie("app-language", {
		default: () => "zh-TW",
		maxAge: 60 * 60 * 24 * 365,
		sameSite: "lax",
	});
	initLocaleCookie(localeCookie);

	const route = useRoute();
	let initialLang;

	if (import.meta.server) {
		initialLang = resolveSsrLocale(route.path);
		nuxtApp.payload.i18nLocale = initialLang;
	} else {
		initialLang = resolveHydrationLocale(route.path, nuxtApp.payload.i18nLocale);
	}

	const i18n = createI18nInstance(initialLang);
	nuxtApp.vueApp.use(i18n);

	const pending = consumePendingClientLocale();
	if (pending) {
		nuxtApp.hook("app:mounted", () => {
			if (i18n.global.locale.value !== pending) {
				setLanguage(pending);
			}
		});
	}

	if (import.meta.client) {
		const router = useRouter();
		router.afterEach(to => {
			const fromPath = parseLocaleFromPath(to.path);
			const next = resolveAppLocale(to.path);
			if (i18n.global.locale.value !== next) {
				// URL 带语言前缀时同步切换并写入 cookie；无前缀仅改运行时
				setLanguage(next, { persist: Boolean(fromPath) });
				return;
			}
			// 已与 URL 一致但偏好未更新时，写回 cookie，保证下次进入保持该语言
			if (fromPath && readStoredLanguagePreference() !== fromPath) {
				setLanguage(fromPath, { persist: true });
			}
		});
	}

	return {
		provide: {
			i18n,
		},
	};
});
